module.exports = __webpack_public_path__ + "img/dwf_ch_belegar_ironhammer_0.48ffcf0f.png";